<template>
<div class="card animated fadeIn">
    <div v-if="!loading">
        <b-card :style="{'background-color': getColor(device.presence)}">
            <b-container fluid class="bv-example-row">
                <b-row :style="{'background-color': getColor(device.presence)}">
                    <b-col md="8">
                        <div slot="header">
                            <strong>Name:{{device.name}} Serial:{{device.serial}} MAC:{{ device.mac }}</strong>
                        </div>
                    </b-col>
                    <b-col md="4">
                        <div align=right slot="header">
                            Last checkin {{relativeTime(device.recent_checkin)}}
                            <b-button :disabled="!isActive" class="btn btn-primary btn-sm " variant="info" v-if="this.timer===true && device.presence" @click="sendCmd(device.id, 'refresh', 1000)">
                                <b-overlay :show="busy" rounded spinner-small spinner-variant="primary">
                                <i class="fa fa-refresh"></i>
                                </b-overlay>
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
            <b-tabs pills v-model="tabIndex" card lazy>
                <b-tab title="Status">
                    <status :device="device" :changed="changed" @getData_event="getData"></status>
                </b-tab>
                <b-tab title="Configuration">
                    <b-card-text>
                        <!--    <keep-alive> -->
                        <network :device="device" :account_opts="account_opts" :changed="changed" :changes="changes"></network>
                        <!-- </keep-alive> -->
                    </b-card-text>
                </b-tab>
                <b-tab title="Diagnostics">
                    <diagnostics :device="device" :changed="changed" @getData_event="getData"></diagnostics>
                </b-tab>
                <b-tab title="Preferences">
                    <preferences :device="device" :changed="changed"></preferences>
                </b-tab>

                <!--                     <b-tab title="Expert Mode">
            <full :device="device" :changed="changed" :changes="changes"></full>
          </b-tab> -->
            </b-tabs>
        </b-card>
    </div>
    <!--     <ul id="example-1">
      <li v-for="change in this.changed">
        {{ change.name }} : {{ change.value}}
      </li>
    </ul>
    <div class="text-center">
      <button v-if="kount" class="btn btn-primary" @click.prevent="onSubmit">Send to Device</button>
      <button v-if="kount" class="btn btn-secondary" @click.prevent="onReset">Reset</button>
    </div> -->
</div>
</template>

<!-- 

default vale: https://michaelstivala.com/setting-the-default-value-of-a-select-tag-in-vuejs/
https://medium.com/@hugodesigns/how-to-use-the-most-complete-selecting-solution-for-vue-js-f991b2605364 
https://medium.com/employbl/build-tagging-with-vue-multiselect-and-laravel-tags-960c260df438

saving selected tags:
https://quickadminpanel.com/blog/add-tags-to-articles-laravel-many-to-many-relationships-with-select2/

for selected tags using only ids:
https://github.com/shentao/vue-multiselect/issues/133

grand-parent <-> parent <-> child events
https://codepen.io/tosite/pen/dKMNxY
-->

<script>
import moment from 'moment'
import Multiselect from 'vue-multiselect'

import Status from "@/readynet/devices/status/index";
import Network from "@/readynet/devices/network/index";
import Full from "@/readynet/devices/network/Full";
import Diagnostics from "@/readynet/devices/diagnostics/index";
import Preferences from "@/readynet/devices/preferences/index";

export default {
    components: {
        Multiselect,
        'status': Status,
        'network': Network,
        'full': Full,
        'diagnostics': Diagnostics,
        'preferences': Preferences,

    },
    data() {
        return {
            busy: false,
            isActive: true,
            timer: false,
            stReturn: 0,
            tabIndex: 0,
            loading: false,
            // selected: "Full",
            // tabs: ["Status", "Network"],
            device: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            account_opts: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            changed: [], // {param: "radio0_country", value: "", name: "Radio 0 Reg Domaini"},
            changes: {},
            submitted: false,
            value: [],
            options: [],
            selectedIds: [],
        };
    },
    // https://github.com/shentao/vue-multiselect/issues/263
    watch: {
        value(newValues) {
            this.selectedIds = newValues.map(obj => obj.id);
        },
        tabIndex(newIndex) {
            localStorage.tabIndex = JSON.stringify(newIndex);
        }
    },
    created() {

        this.timer = setInterval(this.enableTimer, 1000);

        this.loading = true;
        this.getData();
        // let uri = `/api/devices/${this.$route.params.id}?meta=1`;
        // axios.get(uri).then((response) => {
        //     this.device = response.data.data.device;
        //     this.account_opts = response.data.data.account_opts;
        //     this.loading = false;
        // });

    },

    computed: {
        optionsArray() {
            return Object.keys(this.options).map(i => this.options[i]);
        },
        kount: function () {
            return this.changed.length
        },
    },
    mounted() {
        if (localStorage.tabIndex) {
            this.tabIndex = parseInt(localStorage.tabIndex);
        }
    },
    methods: {
        getData() {
            let uri = `/api/devices/${this.$route.params.id}?meta=1`;
            axios.get(uri).then((response) => {
                this.device = response.data.data.device;
                this.account_opts = response.data.data.account_opts;
                this.loading = false;
            });

        },

        relativeTime(value) {
            let localTime = moment.utc(value).local();
            return (value == null) ? '-' : moment(localTime).fromNow()
        },
        enableTimer() {
            this.timer = true;
        },
        getColor(val) {
            return (val === 1) ? "#a7d8e5" : "#FFA07A";
        },
        fetchOptions() {
            let uri = `/api/devices/${this.$route.params.id}`;
            axios.get(uri).then((response) => {
                this.device = response.data.data.device;
                this.options = response.data.data.all_prods_list;
                // this.value = response.data.data.sel_prods_list;
            });
        },

        onSubmit() {
            this.submitted = true;
            this.busy = true;
            // this.device.change_list = this.changes;
            this.$validator.validate().then(valid => {
                if (valid) {
                    let uri = `/api/devices/${this.device.id}`;
                    axios.patch(uri, this.device).then((response) => {

                        if (response.data.success === true) {
                            this.makeToast('info', 'Router updated.');
                            window.location.reload();
                        } else {
                            this.makeToast('danger', 'Unable to update device.');
                        }

                    });

                }
            });
        },

        makeToast(variant = null, message = null) {

            this.$bvToast.toast(message, {
                // title: `Device Updated ${variant || 'default'}`,
                title: `Notification:`,
                variant: variant,
                toaster: 'b-toaster-top-center',
                auto_hide_delay: 1000,
                solid: true
            });
            // toast.show();
        },
        sendCmd(id, op, wait) {
            this.busy = true;
            this.isActive = false;
            let uri = `/api/devices/${this.device.id}/op?op=${op}`;
            axios.get(uri).then((response) => {

                if (response.data.success === true) {
                    const sec = wait > 1000 ?
                        ' seconds' :
                        ' second';
                    let msg = 'Request sent.' + ' Wait ' + wait / 1000 + sec;

                    this.makeToast('info', msg);
                    // this.stReturn = setTimeout(() => { location.reload(); }, wait);
                    this.stReturn = setTimeout(() => {
                        this.getData();
                        this.isActive = true;
                        this.busy=false;
                    }, wait);
                } else {
                    this.makeToast('danger', 'Unable to update device.');
                }

            });
        },
        onReset() {
            window.location.reload();
        },

    },
    beforeDestroy() {
  //      console.log("Destroyed")
        clearInterval(this.timer);
        clearTimeout(this.stReturn);
    },
}
</script>

<style>
.tab-content {
    margin-top: -1px;
    background: #fff;
    border: 0px solid #eee;
}

.multiselect__tag {
    position: relative;
    display: inline-block;
    padding: 4px 26px 4px 10px;
    border-radius: 5px;
    margin-right: 10px;
    color: #fff;
    line-height: 1;
    background: #20a8d8;
    margin-bottom: 5px;
    white-space: nowrap;
    overflow: hidden;
    max-width: 100%;
    text-overflow: ellipsis;
}

.multiselect__option--highlight {
    background: #20a8d8;
    outline: none;
    color: white;
}

.multiselect__option--highlight:after {
    content: attr(data-select);
    background: #20a8d8;
    color: white;
}

.card-body {
    flex: 1 1 auto;
    padding: 1.25rem;
    padding-top: 0.1rem;
    padding-right: 0.1rem;
    padding-bottom: 0.1rem;
    padding-left: 0.1rem;
}

.tab-content .tab-pane {
    padding: 0.1rem;
    padding-top: 0.1rem;
    padding-right: 0.1rem;
    padding-bottom: 0.1rem;
    padding-left: 0.1rem;
}

body {
    background-color: #eee;
}
</style>
// toArray(obj_obj) { // return Object.keys(obj_obj).map(i => obj_obj[i]); // }, // reduceChanged() { // return _.mapValues(_.keyBy(this.changed, 'param'), 'value') // }, // reduceChange(){ // this.changed.forEach(({param, value})=>{ // this.changes[param] = value; // }) // },
